import React from 'react';
import { Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';
const Footer = () => {
  return <footer className="bg-charcoal text-white" data-id="element-76">
      <div className="container py-12" data-id="element-77">
        <div data-id="element-78">
          {/* Company Info */}
          <div data-id="element-79">
            <div className="text-2xl font-bold font-outfit mb-4" data-id="element-80">
              Settl<span className="text-settl-blue" data-id="element-81">by RollingPay</span>
            </div>
            <p className="text-gray-400 mb-4 text-sm" data-id="element-82">
              Automated bill payments for Malaysian SMEs with 30-day payment
              terms.
            </p>
            <div className="flex space-x-4" data-id="element-83">
              <a href="#" className="text-gray-400 hover:text-settl-blue transition-colors" data-id="element-84">
                <Facebook className="h-5 w-5" data-id="element-85" />
              </a>
              <a href="#" className="text-gray-400 hover:text-settl-blue transition-colors" data-id="element-86">
                <Twitter className="h-5 w-5" data-id="element-87" />
              </a>
              <a href="#" className="text-gray-400 hover:text-settl-blue transition-colors" data-id="element-88">
                <Linkedin className="h-5 w-5" data-id="element-89" />
              </a>
              <a href="#" className="text-gray-400 hover:text-settl-blue transition-colors" data-id="element-90">
                <Instagram className="h-5 w-5" data-id="element-91" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center" data-id="element-92">
          <div className="text-gray-500 text-sm" data-id="element-93">
            © 2023 RollingPay Sdn Bhd. All rights reserved.
          </div>
        </div>
      </div>
    </footer>;
};
export default Footer;